import LeagueIcon from '@/pages/challenge/icons/AutumnLeagueIcon';
import BannerBg from '@/assets/images/school-league/autumn_banner_bg.svg';
import Bg from '@/assets/images/school-league/autumn_bg.svg';
const color = '#EFCF90';

const challengeCardBackgroundColor = color;
const ChallengeNavigationIcon = LeagueIcon;
const schoolLeagueBackground = BannerBg;
const schoolLeaguePageBackground = Bg;

export {
  challengeCardBackgroundColor,
  ChallengeNavigationIcon,
  schoolLeagueBackground,
  schoolLeaguePageBackground
};
